<template>
  <div v-if="propsGuard(chartProps)" v-bind="$attrs">
    <slot v-bind="chartProps"></slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import {
  strikeZonePropsProvider,
  strikeZonePropsGuard,
  strikeZoneSeriesMapper,
  strikeZoneSeriesProvider,
} from '@/components/ui/charts/strikeZoneHelpers';
import HeatMapFilters from '@/components/mixins/charts/HeatMapFilters';
import HasPlayers from '@/components/mixins/HasPlayers'
import Session from '@/models/orm/Session';

export default defineComponent({
  name: 'StrikeZoneHeatmapDataProvider',

  mixins: [HeatMapFilters, HasPlayers],

  props: {
    session: {
      type: Object,
      required: true,
    },
    playerId: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      /** @type {{hidden?: boolean, title?: string, description?: string, value?: any}} */
      chartProps: {
        hidden: false,
        title: '',
        description: '',
        value: null,
      },
    };
  },

  methods: {
    propsGuard: strikeZonePropsGuard,
    /**
     *
     * @param {{session: Session, playerId: Number}} val
     * @param oldVal
     */
    watchedHandler({ session, playerId }, oldVal) {
      if (!session || !playerId) {
        return;
      }
      const player = session.getPlayer(playerId);
      const playerName = player ? player.FormattedName : 'Unknown Player';

      const { resultsv1 = [] } = session;

      const chartSeries = strikeZoneSeriesProvider(
        null,
        resultsv1,
        { batterIds: [playerId] }
      );

      const series = strikeZoneSeriesMapper(null, null, [chartSeries]);

      this.chartProps = strikeZonePropsProvider(null, series, {
        conf: {
          title: `Strike Zone Heatmap for ${playerName}`,
          playerName
        },
      });
    },
  },

  watch: {
    watched: {
      handler: 'watchedHandler',
      deep: true,
      immediate: true,
    }
  },

  computed: {
    watched() {
      return { session: this.session, playerId: this.playerId };
    },
  },
});
</script>
